import { RouteGuard } from '@/router/routeGuard';
import { RouteConfig } from 'vue-router';


const routes: Array<RouteConfig> = [
    {
      path: "/orcamento-auto-online/orcamentos-solicitados",
      name: "OrcamentosSolicitados",
      component: () => import("@/views/private/orcamento-auto-online/OrcamentosSolicitados.vue"),
      beforeEnter: RouteGuard.acessoOrcamento
    },
    {
      path: "/orcamento-auto-online/detalhes-orcamento/:id",
      name: "DetalhesOrcamento",
      component: () => import("@/views/private/orcamento-auto-online/DetalhesOrcamento.vue"),
      beforeEnter: RouteGuard.acessoOrcamento
    },
    {
      path: "/orcamento-auto-online/faixa-preco",
      name: "FaixaDePrecoConcerto",
      component: () => import("@/views/private/orcamento-auto-online/FaixaDePrecoConcerto.vue"),
      beforeEnter: RouteGuard.acessoOrcamento
    },
    
]

export default routes;